import { useTranslate } from "ra-core";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const STYLES: Record<string, string> = {
  connected: "bg-success text-success-foreground",
  pending:
    "bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-100",
  error: "bg-destructive text-white",
  disconnected: "bg-muted text-muted-foreground",
};

/** Status badge of the mailbox or the calendar, with the last error below it. */
export const MailStatus = ({
  kind,
  status,
  error,
}: {
  kind: "mailbox" | "calendar";
  status: string;
  error?: string | null;
}) => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col items-end gap-1">
      <Badge
        className={cn("font-normal", STYLES[status] ?? STYLES.disconnected)}
      >
        {translate(`crm.mail.${kind}.status.${status}`)}
      </Badge>
      {status === "error" && error ? (
        <span className="text-xs text-destructive text-right max-w-60">
          {translate(`crm.mail.errors.${error}`, {
            _: translate("crm.mail.errors.unknown"),
          })}
        </span>
      ) : null}
    </div>
  );
};
